<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaProfissoes"
        sort-name="nome"
        :title-table="$t('Professions')"
        module="professionsSettingsModule"
        add-permission="ROLE_PROFISSAO_INSERIR"
        view-permission="ROLE_PROFISSAO_CONSULTAR"
        edit-permission="ROLE_PROFISSAO_ATUALIZAR"
        delete-permission="ROLE_PROFISSAO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <form-profession
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormProfession from './forms/FormProfession.vue'

export default {
  name: 'Professions',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormProfession,
  },
  computed: {
    ...mapState('professionsSettingsModule', {
      listaProfissoes: state => state.listaProfissoes,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'nome',
        },
        {
          label: 'CBO',
          field: 'cbo',
        },
        {
          label: this.$t('Active'),
          field: 'ativo',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('professionsSettingsModule/prepareToEditProfession', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
